import { render, staticRenderFns } from "./Conjuntos.vue?vue&type=template&id=40079697&"
import script from "./Conjuntos.vue?vue&type=script&lang=js&"
export * from "./Conjuntos.vue?vue&type=script&lang=js&"
import style0 from "./Conjuntos.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports